import { system } from 'styled-system';
import { SquareButtonVariant } from './SquareButton.decl';
export var makeSquareButtonVariant = function makeSquareButtonVariant(_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme,
      variant = _ref.variant;
  var colors = theme.colors;

  if (disabled) {
    return {
      backgroundColor: colors.grey.light,
      borderColor: colors.grey.light,
      color: colors.grey.dark,
      svg: {
        fill: colors.grey.dark
      }
    };
  }

  if (variant !== SquareButtonVariant.DEFAULT) {
    return;
  }

  return {
    backgroundColor: colors.base.white,
    borderColor: colors.base.white,
    svg: {
      fill: colors.secondary.base
    },
    ':hover': {
      borderColor: colors.grey.lighter,
      svg: {
        fill: colors.secondary.base
      }
    },
    ':active': {
      borderColor: colors.grey.base,
      svg: {
        fill: colors.secondary.base
      }
    },
    ':focus': {
      borderColor: colors.grey.lighter,
      svg: {
        fill: colors.secondary.base
      }
    }
  };
};
export var square = system({
  square: {
    properties: ['width', 'height'],
    scale: 'sizes'
  }
}); // Props that should not be forwarded to the HTML DOM elements

export var shouldForwardProp = function shouldForwardProp(prop) {
  return !['square'].includes(prop);
};